<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2x"><a id="page_x"></a><a id="page_xi"></a><a id="abb"></a>List of Abbreviations</h2>
<h3 class="h3x">WORKS BY HANS-GEORG GADAMER</h3>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody><tr>
<td style="width:20%" valign="top"><p class="tablex"><em>BP</em></p></td>
<td style="width:80%" valign="top"><p class="tabley"><em>The Beginning of Philosophy</em></p></td>
</tr>
<tr>
<td valign="top"><p class="tablext"><em>CPA</em></p></td>
<td valign="top"><p class="tableyt"><em>Century of Philosophy</em></p></td>
</tr>
<tr>
<td valign="top"><p class="tablext"><em>HD</em></p></td>
<td valign="top"><p class="tableyt"><em>Hegel’s Dialectic</em></p></td>
</tr>
<tr>
<td valign="top"><p class="tablext"><em>GW</em></p></td>
<td valign="top"><p class="tableyt"><em>Gesammelte Werke</em></p></td>
</tr>
<tr>
<td valign="top"><p class="tablext">GW 1</p></td>
<td valign="top"><p class="tableyt">Hermeneutik I: Wahrheit und Methode</p></td>
</tr>
<tr>
<td valign="top"><p class="tablext">GW 2</p></td>
<td valign="top"><p class="tableyt">Hermeneutik II: Wahrheit und Methode, Ergänzungen</p></td>
</tr>
<tr>
<td valign="top"><p class="tablext">GW 3</p></td>
<td valign="top"><p class="tableyt">Neuere Philosophie I: Hegel, Husserl, Heidegger</p></td>
</tr>
<tr>
<td valign="top"><p class="tablext">GW 4</p></td>
<td valign="top"><p class="tableyt">Neuere Philosophie II: Probleme, Gestalten</p></td>
</tr>
<tr>
<td valign="top"><p class="tablext">GW 8</p></td>
<td valign="top"><p class="tableyt">Ästhetik und Poetik I: Kunst als Aussage</p></td>
</tr>
<tr>
<td valign="top"><p class="tablext">GW 10</p></td>
<td valign="top"><p class="tableyt">Hermeneutik im Rückblick</p></td>
</tr>
<tr>
<td valign="top"><p class="tablext"><em>PH</em></p></td>
<td valign="top"><p class="tableyt"><em>Philosophical Hermeneutics</em></p></td>
</tr>
<tr>
<td valign="top"><p class="tablext"><em>RAS</em></p></td>
<td valign="top"><p class="tableyt"><em>Reason in the Age of Science</em></p></td>
</tr>
<tr>
<td valign="top"><p class="tablext"><em>TM</em></p></td>
<td valign="top"><p class="tableyt"><em>Truth and Method</em></p></td>
</tr>
</tbody></table>
<h3 class="h3y">WORKS BY G. W. F. HEGEL</h3>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody><tr>
<td style="width:30%" valign="top"><p class="tablext"><a id="page_xii"></a><em>IPH</em></p></td>
<td style="width:70%" valign="top"><p class="tableyt"><em>Introduction to the Philosophy of History</em></p></td>
</tr>
<tr>
<td valign="top"><p class="tablext"><em>PR</em></p></td>
<td valign="top"><p class="tableyt"><em>Philosophy of Right</em></p></td>
</tr>
<tr>
<td valign="top"><p class="tablext"><em>PS</em></p></td>
<td valign="top"><p class="tableyt"><em>Phenomenology of Spirit</em></p></td>
</tr>
<tr>
<td valign="top"><p class="tablext"><em>RH</em></p></td>
<td valign="top"><p class="tableyt"><em>Reason in History</em></p></td>
</tr>
<tr>
<td valign="top"><p class="tablext"><em>SL</em></p></td>
<td valign="top"><p class="tableyt"><em>Science of Logic</em></p></td>
</tr>
</tbody></table>
<h3 class="h3y">WORKS BY MARTIN HEIDEGGER</h3>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody><tr>
<td style="width:30%" valign="top"><p class="tablext"><em>BW</em></p></td>
<td style="width:70%" valign="top"><p class="tableyt"><em>Basic Writings</em>, ed. by Krell</p></td>
</tr>
<tr>
<td valign="top"><p class="tablext">GA</p></td>
<td valign="top"><p class="tableyt"><em>Gesamtausgabe</em> (volume numbers listed in bibliography)</p></td>
</tr>
<tr>
<td valign="top"><p class="tablext"><em>HR</em></p></td>
<td valign="top"><p class="tableyt"><em>The Heidegger Reader</em>, ed. by Figal</p></td>
</tr>
<tr>
<td valign="top"><p class="tablext"><em>SZ</em></p></td>
<td valign="top"><p class="tableyt"><em>Sein und Zeit</em>, Niemeyer edition</p></td>
</tr>
</tbody></table>
<h3 class="h3y">WORKS BY IMMANUEL KANT</h3>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody><tr>
<td style="width:30%" valign="top"><p class="tablext"><em>CJ</em></p></td>
<td style="width:70%" valign="top"><p class="tableyt"><em>Critique of Judgment</em></p></td>
</tr>
<tr>
<td valign="top"><p class="tablext"><em>CPR</em></p></td>
<td valign="top"><p class="tableyt"><em>Critique of Pure Reason</em></p></td>
</tr>
</tbody></table>
<h3 class="h3y">OTHER FREQUENTLY CITED VOLUMES</h3>
<table border="0" cellpadding="0" cellspacing="0" width="100%">
<tbody><tr>
<td style="width:30%" valign="top"><p class="tablext"><em>DH</em></p></td>
<td style="width:70%" valign="top"><p class="tableyt"><em>Dimensionen des Hermeneutischen</em>, ed. by Figal and Gander</p></td>
</tr>
<tr>
<td valign="top"><p class="tablext"><em>GC</em></p></td>
<td valign="top"><p class="tableyt"><em>Gadamer’s Century</em>, ed. by Malpas, Arnswald, and Kertscher</p></td>
</tr>
<tr>
<td valign="top"><p class="tablext"><a id="page_xiii"></a><em>HAC</em></p></td>
<td valign="top"><p class="tableyt"><em>Gadamer’s Hermeneutics and the Art of Conversation</em>, ed. Andrzej Wiercinski</p></td>
</tr>
<tr>
<td valign="top"><p class="tablext"><em>HVO</em></p></td>
<td valign="top"><p class="tableyt"><em>Hermeneutics and the Voice of the Other</em>, by Risser</p></td>
</tr>
<tr>
<td valign="top"><p class="tablext"><em>HW</em></p></td>
<td valign="top"><p class="tableyt"><em>Hermeneutische Wege</em>, ed. by Figal, Grondin, and Schmidt</p></td>
</tr>
<tr>
<td valign="top"><p class="tablext">KA 27</p></td>
<td valign="top"><p class="tableyt"><em>Sein und Zeit</em>, ed. by Rentsch</p></td>
</tr>
<tr>
<td valign="top"><p class="tablext">KA 30</p></td>
<td valign="top"><p class="tableyt"><em>Wahrheit und Methode</em>, ed. by Figal</p></td>
</tr>
<tr>
<td valign="top"><p class="tablext"><em>SR</em></p></td>
<td valign="top"><p class="tableyt"><em>The Specter of Relativism</em>, ed. by Schmidt</p></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abbreviations.vue?f0c22514